import React, { useRef, useState } from 'react';
import { Button } from 'antd';
import { FooterView, LogoWrapView } from '../Components';

import './homeView.css';
import { qualificationsList, systemList } from '../../Mock';
import { useNavigate } from 'react-router-dom';
import publics from './images/img_v2_306f60fe-58ed-49b5-b9c6-6ff39ff3e50g.png';
import home_link from '../../assets/homeImages/home_images/home_link.png';
import imageAan from '../../assets/homeImages/home_images/home_1.png';
import imageBan from '../../assets/homeImages/home_images/home_2.png';
import imageCan from '../../assets/homeImages/home_images/home_3.png';
import imageDan from '../../assets/homeImages/home_images/home_4.png';
import imageAanNa from '../../assets/homeImages/home_switch_image/home_1_2.png';
import imageBanNa from '../../assets/homeImages/home_switch_image/home_2_2.png';
import imageCanNa from '../../assets/homeImages/home_switch_image/home_3_2.png';
import imageDanNa from '../../assets/homeImages/home_switch_image/home_4_2.png';
import home_bg_left from '../../assets/homeImages/home_images/home_bg_left.png';
import home_bg_right from '../../assets/homeImages/home_images/home_bg_right.png';
import { FullScreenVideo } from './FullScreenVideo';

const companyProfile = {
  company: '天津挚云数字科技有限公司',
  introduction: '助力客户业务流程规范化、线上流程全面化、业务辅助智能化',
};

const HomeView = () => {
  const item_row = useRef();
  const navigate = useNavigate();
  const [hoveredIndex, setHoveredIndex] = useState(null);
  const [industrySolutionsList, setIndustrySolutionsList] = useState([
    {
      id: '1',
      img: imageAan,
      imgMultiple: imageAanNa,
      title: '保理系统',
      segmentShow: true,
      English: 'Factoring System',
      url: '/solution/factoring',
      word: '保理系统是针对保理业务的流程结合互联网金融而开发的一套计算机软件管理系统，系统支持正向保理、反向保理、融资性/非融资性保理、再保理、ABS资产证券化等业务模式。',
    },
    {
      id: '2',
      img: imageBan,
      imgMultiple: imageBanNa,
      title: '贸易系统',
      segmentShow: true,
      English: 'Trade System',
      url: '/solution/trade',
      word: '贸易系统专为贸易企业提供，建立以业务为导向，把销售、采购、仓库、财务各个部门流程串通起来，提高各部门协同效率，让各个环节高效运转，从而提升企业的整体运营效率。',
    },
    {
      id: '3',
      img: imageCan,
      imgMultiple: imageCanNa,
      title: '供应链金融',
      segmentShow: true,
      English: 'Supply Chain Finance',
      url: '/solution/supply',
      word: '供应链金融系统深入供应链各环节，借助互联网、大数据、人工智能等信息技术，解决核心企业、上下游企业各个场景的融资要求，优化供应链金融产业链，提高资金周转率。',
    },
    {
      id: '4',
      img: imageDan,
      imgMultiple: imageDanNa,
      title: '融资租赁',
      segmentShow: true,
      English: 'Finance Lease',
      url: '/solution/financial/leasing',
      word: '融资租赁系统预置了16个直租和回租风控引擎、业务初审表等风控理念，涵盖了国内、进口设备、不动产、转租赁、国际租赁等业务类型，实现了所有租赁业务全流程数字化、所有租赁物全生命周期数字化管理。',
    },
  ]);

  const boxStyle = {
    position: 'relative',
    animationName: 'solveBox',
    animationDuration: '1s',
    animationFillMode: 'forwards',
    background: '#4373e8',
    color: '#fff',
  };
  const handleMouseEnter = (index) => {
    setHoveredIndex(index); // 设置当前鼠标滑过的索引
  };

  const handleMouseLeave = () => {
    setHoveredIndex(null); // 清除鼠标滑过的索引
  };
  return (
    <div className="home">
      <FullScreenVideo />
      <div className="main">
        {/* 行业解决方案 */}
        <div className="industry">
          <div className="industry-title">
            <div className="industry-title-Ch">行业解决方案</div>
            <p className="industry-title-En">INDUSTRY SOLUTION</p>
          </div>
          <div className="industry-segment">
            {industrySolutionsList.length > 0 &&
              industrySolutionsList.map((item, index) => {
                return (
                  <div
                    onMouseEnter={() => handleMouseEnter(index)}
                    onMouseLeave={() => handleMouseLeave(index)}
                    className="segment-piece-box"
                  >
                    <div
                      key={item.id}
                      className="segment-piece"
                      ref={item_row}
                      onClick={() => navigate(item.url)}
                      style={hoveredIndex === index ? boxStyle : null}
                    >
                      <div className="segment-piece-img">
                        <img
                          src={
                            hoveredIndex === index ? item.imgMultiple : item.img
                          }
                          alt=""
                        />
                      </div>
                      <div className="segment-title">{item.title}</div>
                      <div className="segment-English">{item.English}</div>
                      <div className="segment-word">{item.word}</div>
                    </div>
                  </div>
                );
              })}
          </div>
        </div>
        {/* 产品服务 */}
        <div className="product-services">
          <img className="home_bg_left" src={home_bg_left} alt="" />
          <img className="home_bg_right" src={home_bg_right} alt="" />
          <div className="product-center">
            <div className="products">
              <div>
                <span className="products-a">——</span>
                <span className="products-b">&emsp;产品服务&emsp;</span>
                <span className="products-a">——</span>
              </div>
              <div className="products-en">Product Services</div>
            </div>
            <div className="company">{companyProfile.company}</div>
            <div className="introduction">{companyProfile.introduction}</div>
          </div>
          {/* 定位 */}
          <div className="services">
            <div
              className="services-operate"
              onClick={() => navigate('/product/services')}
            >
              <span className="services-weight">系统服务</span>
              <span className="services-weight-en">System Service</span>
            </div>
            <div className="home_link">
              <img src={home_link} alt="" />
            </div>
            <div
              className="services-operate"
              onClick={() => navigate('/product/services')}
            >
              <span className="services-weight">运营服务</span>
              <span className="services-weight-en">Operation Service</span>
            </div>
            <div>
              <img src={home_link} alt="" />
            </div>
            <div
              className="services-operate"
              onClick={() => navigate('/product/services')}
            >
              <span className="services-weight">定制服务</span>
              <span className="services-weight-en">Customize Service</span>
            </div>
          </div>
        </div>
        {/* 系统 */}
        <div className="system">
          {systemList.length > 0 &&
            systemList.map((item) => {
              return (
                <div key={item.id} className="system-all">
                  <div className="system-img">
                    <img src={item.img} alt="" />
                  </div>
                  <div className="system-bum">
                    <div className="system-title">{item.serving}</div>
                    <div className="item-lei">
                      {item.array.map((v, i) => (
                        <span key={i}>{v}</span>
                      ))}
                    </div>
                    <Button
                      type="primary"
                      className="system-btn"
                      onClick={() => navigate(`/product/services`)}
                    >
                      了解详情
                    </Button>
                  </div>
                </div>
              );
            })}
        </div>
        <div className="reveal">
          <div className="reveal-row">
            <span className="simple">
              简单易用的低代码平台,让企业流程更敏捷
            </span>
            <p className="manage">
              帮助企业建立统一的信息管理平台、深入企业业务,打破组织的扁平化管理,帮助企业建立差异化竞争优势
            </p>
          </div>
          <div className="public">
            <img src={publics} alt="" />
          </div>
        </div>
        <div className="bg-qual">
          {/* 我们的资质 */}
          <div className="qualifications">
            <div className="qualifications-one">
              <div className="qualifications-title">
                <div className="qualifications-title-Ch">我们的资质</div>
                <div className="qualifications-title-En">
                  OUR QUALIFICATIONS
                </div>
                <div className="qualifications-line"></div>
              </div>
              <div className="sprite">
                {qualificationsList.length > 0 &&
                  qualificationsList.map((ite) => {
                    return (
                      <div
                        key={ite.id}
                        className="sprite-bg-img"
                        id="sprite-color"
                      >
                        <div className="sprite-year">{ite.year}</div>
                        <div className="sprite-word">
                          <div className="">{ite.word}</div>
                          <div className="">{ite.position}</div>
                        </div>
                      </div>
                    );
                  })}
              </div>
            </div>
          </div>
          {/* 合作伙伴 */}
          <div className="partners">
            <div className="qualifications-title">
              <div className="qualifications-title-Ch">合作伙伴</div>
              <div className="qualifications-title-En">COOPERATIVE PARTNER</div>
            </div>
            <LogoWrapView />
          </div>
        </div>
      </div>
      <FooterView />
    </div>
  );
};

export default HomeView;
